import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // ১. ডাইনামিক লিঙ্কের জন্য useNavigate ইমপোর্ট করা হলো

const Buttonanimated = ({ text = "Contact Us" }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate(); // ২. নেভিগেশন ফাংশন ইনিশিয়ালাইজ করা হলো

  const handleClick = () => {
    navigate('/contact'); // ৩. বাটনে ক্লিক করলে dynamically /contact পেজে নিয়ে যাবে
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>

      {/* Pulsing Glow (ডিজাইন অপরিবর্তিত) */}
      <motion.div
        animate={{
          opacity: [0.3, 0.7, 0.3],
          scale: [1, 1.08, 1],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          position: 'absolute',
          inset: '-6px',
          borderRadius: '14px',
          background: '#b22335',
          filter: 'blur(15px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      {/* Main Button */}
      <motion.button
        className="btn px-4 py-1.5 fw-bold position-relative overflow-hidden"
        onClick={handleClick} // ৪. এখানে ক্লিক হ্যান্ডলার যুক্ত করা হলো
        style={{
          background: isHovered ? '#3D3B6D' : '#b22335',
          color: '#ffffff',
          border: `2px solid ${isHovered ? '#3D3B6D' : '#b22335'}`,
          borderRadius: '12px',
          fontSize: '1rem',
          letterSpacing: '0.5px',
          zIndex: 1,
          cursor: 'pointer',
          transition: 'background 0.4s ease, border-color 0.4s ease, color 0.3s ease',
        }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        whileHover={{
          scale: 1.06,
          y: -4,
          boxShadow: `0 15px 40px rgba(178, 35, 53, 0.35)`
        }}
        whileTap={{
          scale: 0.94,
          boxShadow: `0 5px 15px rgba(178, 35, 53, 0.2)`
        }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 15
        }}
      >

        {/* Shimmer Effect (ডিজাইন অপরিবর্তিত) */}
        <motion.span
          className="position-absolute"
          style={{
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
            zIndex: 2,
            pointerEvents: 'none',
          }}
          animate={{
            left: isHovered ? '100%' : '-100%',
          }}
          transition={{
            duration: 0.6,
            ease: "easeInOut"
          }}
        />

        {/* Gradient Overlay (ডিজাইন অপরিবর্তিত) */}
        <motion.div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%)',
            zIndex: 1,
            pointerEvents: 'none',
          }}
          animate={{ opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
        />

        {/* Button Content (ডিজাইন অপরিবর্তিত) */}
        <span
          className="position-relative d-flex align-items-center gap-2"
          style={{ zIndex: 3 }}
        >
          {text}

          <motion.span
            animate={{
              x: isHovered ? 6 : 0,
              rotate: isHovered ? 0 : -45,
              opacity: isHovered ? 1 : 0.5,
            }}
            transition={{
              type: "spring",
              stiffness: 500,
              damping: 12
            }}
            style={{ display: 'inline-flex', fontSize: '1.2rem' }}
          >
            →
          </motion.span>
        </span>
      </motion.button>

    </div>
  );
};

export default Buttonanimated;